/* eslint-disable */

import React, {Component} from 'react'
import Loader from '../../loaders/loader'
import {Link} from 'react-router-dom'
import HeaderGrid from '../../Pagination/HeaderGrid'
import Sort from '../../Pagination/Sort'
import Pageing from '../../Pagination/pageing'
import http from '../../Interceptor/Interseptor'
import PAYMENT from '../../BaseComponent/PAYMENT'
import $ from 'jquery'
import jMoment from 'moment-jalaali'

class DetailTerminal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      details: [],
      printInfo: [],
      lengthDetails: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',

      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد رهگیری',
          value: 'trackingCode',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'شماره کارت',
          value: 'cardNumber',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'قیمت',
          value: 'price',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'کد مرجع',
          value: 'referenceCode',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت تراکنش',
          value: 'transactionStatus',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان',
          value: 'time',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شماره ترمینال',
          value: 'terminalId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه عملیات',
          value: 'operationId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شماره مرجع پرسینا',
          value: 'persinaRefNumber',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان ثبت در پرسینا',
          value: 'persinaRegisteredTime',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه پرداخت مشتری',
          value: 'customerPaymentId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت پردازش',
          value: 'processStatus',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  componentDidMount() {
    this.getdetails()
  }

  getdetails = () => {
    this.setState({
      loading: true
    })
    let Tid = this.props.match.params.id
    let data = {
      pageSize: this.state.pageSize,
      pageNumber: this.state.pageNumber,
      sortBy: this.state.sortBy,
      export: false,
      masterId: Tid
    }
    http
      .get(`${PAYMENT.TRANSACTION_DETAILS_OF_LIST_PAYMENT}`, {
        params: data
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable').fadeIn()
          this.setState({
            details: response.data.object.result,
            lengthDetails: response.data.object.countAll,
            loading: false
          })
        } else {
          this.setState({
            loading: false
          })
          $('.showBaseTable').fadeOut()
          alert(6854)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getdetails()
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getdetails()
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getdetails()
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    return (
      <div className="rtl">
        <Loader show={loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>جزییات</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/Report/TerminalHistory'} enablePageSize />
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                {this.state.details.map((item, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td>{item.trackingCode}</td>
                    <td>{item.cardNumber}</td>
                    <td>{item.price}</td>
                    <td>{item.referenceCode}</td>
                    <td>{item.transactionStatus ? <p> موفق</p> : <p>نا موفق</p>}</td>
                    <td>{jMoment(item.time).format('jYYYY/jMM/jDD HH:mm')}</td>
                    <td>{item.terminalId}</td>
                    <td>{item.operationId}</td>
                    <td>{item.persinaRefNumber}</td>
                    <td>{item.persinaRegisteredTime}</td>
                    <td>{item.customerPaymentId}</td>

                    <td>
                      {item.processStatus ? (
                        <img src={require('../../../image/confirm.svg')} alt="" />
                      ) : (
                        <img src={require('../../../image/ignor.svg')} alt="" />
                      )}
                    </td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthDetails}
                />
              </div>
            </div>
          </div>
        </div>

        {/*<Loader show={loading} ></Loader>*/}
        {/*<div className="printSection">*/}
        {/*    <table*/}
        {/*        className="printTable printReportTable"*/}
        {/*        ref={node => (this.printPart = node)}*/}
        {/*    >*/}
        {/*        <HeaderTablePrint*/}
        {/*            header="گزارش کاردکس"*/}
        {/*            headerColSpan={15}*/}
        {/*            reporter={name}*/}
        {/*            timePrint={jMoment().format("jYYYY/jM/jD HH:mm")}*/}
        {/*            leftColSpan={4}*/}
        {/*            rightColSpan={5}*/}
        {/*            centerColSpan={6}*/}
        {/*            centerSection={"تامین کننده : " + this.state.providerText}*/}
        {/*            rightSection={"موجودی برای انبار : " + this.state.wareTextPrint}*/}
        {/*            columns={columns}*/}
        {/*        />*/}
        {/*        <thead></thead>*/}
        {/*        <tbody>*/}
        {/*        {this.state.printInfo.map((cardex, index) => (*/}
        {/*            <tr key={"i" + index}>*/}
        {/*                <td>{index + 1}</td>*/}
        {/*                <td>*/}
        {/*                    {jMoment(cardex.confirmDate).format("jYYYY/jMM/jDD HH:mm")}*/}
        {/*                </td>*/}
        {/*                <td>{cardex.globalDocNo}</td>*/}
        {/*                <td>*/}
        {/*                    {cardex.manualRegisterDate == null*/}
        {/*                        ? "-"*/}
        {/*                        : jMoment(cardex.manualRegisterDate).format(*/}
        {/*                            "jYYYY/jMM/jDD HH:mm"*/}
        {/*                        )}*/}
        {/*                </td>*/}
        {/*                <td>{cardex.articleId}</td>*/}
        {/*                <td>{cardex.productCode}</td>*/}
        {/*                <td>{cardex.productName}</td>*/}
        {/*                <td>{cardex.warehouseName}</td>*/}
        {/*                <td>{cardex.inQuantity}</td>*/}
        {/*                <td>{cardex.outQuantity}</td>*/}
        {/*                <td>{cardex.remainQuantity}</td>*/}

        {/*                <td>{cardex.input ? "وارده" : "صادره"}</td>*/}
        {/*                <td>{cardex.providerName}</td>*/}
        {/*            </tr>*/}
        {/*        ))}*/}
        {/*        </tbody>*/}
        {/*    </table>*/}
        {/*</div>*/}

        {/*<div className="excelSection">*/}
        {/*    <ExcelExport*/}
        {/*        dir="rtl"*/}
        {/*        ref={exporter => {*/}
        {/*            this._export = exporter;*/}
        {/*        }}*/}
        {/*        fileName="گزارش کاردکس"*/}
        {/*    >*/}
        {/*        <grid style={{ height: "420px" }} data={this.state.excelReport}>*/}
        {/*            <gridColumn*/}
        {/*                key={"confirmDate"}*/}
        {/*                field={"confirmDate"}*/}
        {/*                title={"تاریخ ثبت سند"}*/}
        {/*                width="100px"*/}
        {/*                footerCellOptions={{ wrap: true, textAlign: "center" }}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"globalDocNo"}*/}
        {/*                field={"globalDocNo"}*/}
        {/*                title={"شماره سراسری سند"}*/}
        {/*                width="100px"*/}
        {/*                footerCellOptions={{ wrap: true, textAlign: "center" }}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"manualRegisterDate"}*/}
        {/*                field={"manualRegisterDate"}*/}
        {/*                title={"تاریخ دستی سند"}*/}
        {/*                width="100px"*/}
        {/*                footerCellOptions={{ wrap: true, textAlign: "center" }}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"articleId"}*/}
        {/*                field={"articleId"}*/}
        {/*                title={"کد محصول"}*/}
        {/*                width="100px"*/}
        {/*                footerCellOptions={{ wrap: true, textAlign: "center" }}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"productCode"}*/}
        {/*                field={"productCode"}*/}
        {/*                title={"بارکد"}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"productName"}*/}
        {/*                field={"productName"}*/}
        {/*                title={"نام محصول"}*/}
        {/*            />*/}
        {/*            <gridColumn*/}
        {/*                key={"warehouseName"}*/}
        {/*                field={"warehouseName"}*/}
        {/*                title={"نام انبار"}*/}
        {/*            />*/}
        {/*            <gridColumn*/}
        {/*                key={"inQuantity"}*/}
        {/*                field={"inQuantity"}*/}
        {/*                title={"وارد شده"}*/}
        {/*            />*/}
        {/*            <gridColumn*/}
        {/*                key={"outQuantity"}*/}
        {/*                field={"outQuantity"}*/}
        {/*                title={"خارج شده"}*/}
        {/*            />*/}
        {/*            <gridColumn*/}
        {/*                key={"remainQuantity"}*/}
        {/*                field={"remainQuantity"}*/}
        {/*                title={"مانده"}*/}
        {/*            />*/}

        {/*            <gridColumn key={"input"} field={"input"} title={"ماهیت  سند"} />*/}
        {/*            <gridColumn*/}
        {/*                key={"providerName"}*/}
        {/*                field={"providerName"}*/}
        {/*                title={"تامین کننده"}*/}
        {/*            />*/}
        {/*        </grid>*/}
        {/*    </ExcelExport>*/}
        {/*</div>*/}

        {/*<div className="wrapperIframe">*/}
        {/*    <ul className="breadcrumb">*/}
        {/*        <li>*/}
        {/*            <Link to={"/search"}>به روزرسان</Link>*/}
        {/*        </li>*/}
        {/*        <li>گزارشات</li>*/}
        {/*        <li>تاریخچه انتصاب ترمینال ها</li>*/}
        {/*    </ul>*/}
        {/*    <div className="tableComponent">*/}
        {/*        <div className="tableTools">*/}
        {/*            <div className="tableOptionWrapp">*/}
        {/*                <HeaderGrid*/}
        {/*                    getPageSize={this.getPageSize}*/}
        {/*                    createLink={"//Report/TerminalHistory"}*/}
        {/*                    enablePageSize*/}
        {/*                />*/}
        {/*<button className="filterBtn">*/}
        {/*    <i className="fa fa-search"></i>*/}
        {/*</button>*/}
        {/*<button*/}
        {/*    className={"printButton"}*/}
        {/*    disabled={this.state.buttonClicked ? false : true}*/}
        {/*    onClick={this.exportExcel}*/}
        {/*>*/}
        {/*    <i className="fas fa-file-excel"></i>*/}
        {/*</button>*/}
        {/*<button*/}
        {/*    className="printButton"*/}
        {/*    disabled={this.state.buttonClicked ? false : true}*/}
        {/*    onClick={this.exportPrint}*/}
        {/*>*/}
        {/*    <i className="fas fa-print"></i>*/}
        {/*</button>*/}
        {/*    </div>*/}
        {/*</div>*/}
        {/*<div className="basketFilterComponent">*/}
        {/*    <div className="filterInputs">*/}
        {/*<div className="formComponent">*/}
        {/*<label>تاریخ تا:</label>*/}

        {/*<MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">*/}
        {/*    <DatePicker*/}
        {/*        okLabel="تأیید"*/}
        {/*        cancelLabel="لغو"*/}
        {/*        autoOk={true}*/}
        {/*        leftArrowIcon={<Icon type="left" />}*/}
        {/*        rightArrowIcon={<Icon type="right" />}*/}
        {/*        labelFunc={date =>*/}
        {/*            date == null ? "" : date.format("jYYYY/jMM/jDD")*/}
        {/*        }*/}
        {/*        onChange={this.handleDateChangeTo}*/}
        {/*        TextFieldComponent={this.toDate}*/}
        {/*        id="datePickerTo"*/}
        {/*        name="datePickerTo"*/}
        {/*        value={selectedDateTo}*/}
        {/*        ref={node => (this.toDateInput = node)}*/}
        {/*    />*/}
        {/*</MuiPickersUtilsProvider>*/}
        {/*</div>*/}
        {/*                    <div className="formComponent">*/}
        {/*                        <label>کد ترمینال:</label>*/}
        {/*                        <input*/}
        {/*                            className="form-control"*/}
        {/*                            type="text"*/}
        {/*                            id="terminalCode"*/}
        {/*                        />*/}
        {/*                    </div>*/}

        {/*                </div>*/}
        {/*                <div className="filterOption">*/}
        {/*                    <button*/}
        {/*                        // className="confirmFilter"*/}
        {/*                        // onClick={this.filter.bind(this)}*/}
        {/*                    >*/}
        {/*                        جست و جو*/}
        {/*                    </button>*/}
        {/*                </div>*/}
        {/*            </div>*/}

        {/*            <div className="showBaseTable print">*/}
        {/*                <table className="baseTable">*/}
        {/*                    <Sort data={this.state.sortData} getSort={this.getSort} />*/}
        {/*                    {this.state.terminalHis.map((terminal, index) => (*/}
        {/*                        <tr key={index}>*/}
        {/*                            <td>{(pageNumber - 1) * pageSize + index + 1}</td>*/}
        {/*                            <td>*/}
        {/*                                {terminal.terminalCode}*/}
        {/*                            </td>*/}
        {/*                            <td>{terminal.fromName}</td>*/}
        {/*                            <td>*/}
        {/*                                {terminal.toName}*/}
        {/*                            </td>*/}
        {/*                            <td>*/}
        {/*                                {jMoment(terminal.occurredTime ).format(*/}
        {/*                                    "jYYYY/jMM/jDD HH:mm"*/}
        {/*                                )}*/}
        {/*                            </td>*/}
        {/*                            <td>{terminal.operatorName}</td>*/}

        {/*                        </tr>*/}
        {/*                    ))}*/}
        {/*                </table>*/}
        {/*                <div className="paginationWrapp">*/}
        {/*                    <Pageing*/}
        {/*                        defaultCurrent={1}*/}
        {/*                        getPage={this.getPageNumber}*/}
        {/*                        pageSize={this.state.pageSize}*/}
        {/*                        currentPage={this.state.pageNumber}*/}
        {/*                        total={this.state.lengthTerminalHis}*/}
        {/*                    />*/}
        {/*                </div>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*    </div>*/}
      </div>
    )
  }
}

export default DetailTerminal
